import React from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

export const tableConstants = (permissions, showModel, faqDelete) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{count++}</span>;
      },
    },
    {
      title: 'Question',
      render: rowData => {
        return <span>{rowData.title}</span>;
      },
    },
    {
      title: 'Answer',
      render: rowData => {
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
        return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(rowData.description) }} />
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {permissions.includes('faq.update') &&
            <FontAwesomeIcon
              icon={faEdit}
              style={{
                color: "var(--color-primary-text)",
                marginRight: "10px",
                cursor: "pointer"
              }}
              onClick={() => showModel(rowData)}
            />}
          &nbsp;
          {permissions.includes("faq.delete") &&
            <span
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm(`Are you sure you wish to delete this item?`))
                  faqDelete(rowData.id)
              }}>
              <i className="fa fa-trash text-danger"></i>
            </span>
          }
        </span>;
      },
    },
  ];
  return formatedData;
};
